import { type Column } from '@root/shared/ui-kit'

import { ExploreColumn } from './explore-column'

import type { ExploreTableColumnId } from './explore-column'
import type { ExploreTableContext } from './explore-table-types'
import type { PairModel } from '@root/entities/pair'

export const createExploreTableColumns = ({
  sortable,
}: {
  sortable: boolean
}): Array<Column<PairModel, ExploreTableColumnId, ExploreTableContext>> => {
  return [
    ExploreColumn.Currency,
    ExploreColumn.TokenAddress,
    ExploreColumn.DevTokens,
    // ExploreColumn.CreatedAt,
    ExploreColumn.Liquidity,
    ExploreColumn.Holders,
    ExploreColumn.MarketCap,
    ExploreColumn.Volume,
    ExploreColumn.Swaps,
    ExploreColumn.Audit,
    ExploreColumn.Buy,
  ].map((it) => {
    if ((it as unknown as Column).sortable === true && !sortable) {
      return {
        ...it,
        sortable: false,
      }
    }
    return it
  })
}
